"use client";

import { createContext, useMemo, useState } from "react";

export interface IGlobalState {
  listName?: string;
  workspaceName?: string;
  setListName: (listName: string | undefined) => void;
  setWorkspaceName: (workspaceName: string | undefined) => void;
}

export const GlobalStateContext = createContext<IGlobalState>({
  setListName: () => {},
  setWorkspaceName: () => {},
});

export function GlobalStateProvider(props: { children: React.ReactNode }) {
  const [listName, setListName] = useState<string | undefined>(undefined);
  const [workspaceName, setWorkspaceName] = useState<string | undefined>(
    undefined
  );
  const globalState = useMemo(() => {
    return {
      listName,
      setListName,
      workspaceName,
      setWorkspaceName,
    };
  }, [listName, workspaceName]);

  return (
    <GlobalStateContext.Provider value={globalState}>
      {props.children}
    </GlobalStateContext.Provider>
  );
}
